import React from 'react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Input, Grid, Dropdown, Form, TextArea } from 'semantic-ui-react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import AddSpare from './AddSpares';

import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loadings';
import Server from '../../../functions/server';

export default class JobCard extends React.Component {

    state = {
        item: {}, data: [], filterStatus: 'All', addingspares: []
    }

    getSpares = () => {
        let context = this;
        context.setState({ load: true, message: 'Getting Customer And Labor Details', })
        $.ajax({
            type: 'POST', data: { 'jobcard_id': this.props.item.id }, 
            url: Server() + 'Sales/JobCard/getSpares.php',
            success: function (data) {
                console.log(data);
                try {
                    data = JSON.parse(data);
                    context.setState({ dialog: true, data, load: false })
                } catch (error) {
                    context.setState({ load: false })
                    alert(error)
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    convertIntoNumber(value) {
        try {
            value = Number(value);
        } catch (error) {
            value = 0;
        }
        return value;
    }

    makeDecimal(value) {
        try {
            value = value.toFixed(2);
        } catch (error) {
            value = 0;
        }
        return value;
    }

    editSpares(item) {
        item["oldStock"] = item.qty;
        this.setState({  item, editDialog: true })
    }

    saveSpare = () => {
        let context = this;
        let { item } = this.state;
        if (item.qty > item.oldStock) {
            alert('Stock is more the invoiced stock!!! Only return will accept here!!! Please Add Stock Via Place Order Menu!!!');
            return;
        }
        console.log(item);
        context.setState({ load: true, message: 'Edit Spares', })
        $.ajax({
            type: 'POST', data: item, url: Server() + 'Sales/JobCard/EditSpares.php',
            success: function (data) {
                console.log(data);
                if (data == 1) {
                    context.setState({ editDialog: false, load: false })
                    context.getSpares();
                }
                else {
                    alert(data)
                    console.log(data);
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    deleteSpares = (item) => {
        let context = this;
        context.setState({ load: true, message: 'Edit Spares', })
        $.ajax({
            type: 'POST', data: item, url: Server() + 'Sales/JobCard/DeleteSpares.php',
            success: function (data) {
                if (data == 1) {
                    context.setState({ editDialog: false, load: false })
                    context.getSpares();
                }
                else {
                    alert(data)
                    console.log(data);
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    handleChange = name => event => {
        this.setState({
            item: {
            ...this.state.item,
            [name]: event.target.value,
            },
        });
    };

    handleChange1 = name => event => { this.setState({ [name]: event.target.value }) }

    selectStatus = (f, { value }) => { this.setState({ filterStatus: value }) }

    

    
    render() {
        let { dialog, data, editDialog, item, load, message, search, filterStatus } = this.state;
        let i = 1;
        return (
            <div>
                <center>
                    <u onClick={this.getSpares} style={{color: 'blue', cursor: 'pointer'}}>Spares</u>
                </center>
                <Loading load={load} message={message} />
                <Dialog fullWidth={false} maxWidth={'md'} open={editDialog}
                    onClose={ () => { this.setState({ editDialog: false }) }}>
                    <DialogTitle id="responsive-dialog-title" style={{width: '400px'}}> {"Edit Qty of the Spares"} </DialogTitle>
                    <DialogContent>
                        <b>Enter Returing Qty</b>
                        <Input type="number" fluid max={item.oldStock} placeholder='Enter Returing Qty' value={item.qty} 
                            onChange={this.handleChange('qty')} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ editDialog: false }) }}>Close</Button>
                        <Button onClick={this.saveSpare}>Save Spare</Button>
                    </DialogActions>
                </Dialog>
                <Dialog fullWidth={false} maxWidth={'md'} open={dialog}
                    onClose={ () => { this.setState({ dialog: false }) }}>
                    <DialogTitle id="responsive-dialog-title" style={{width: '800px'}}> {"Spares"} </DialogTitle>
                    <DialogContent>
                        <div style={{display: 'flex'}}>
                            <div>
                                <Input value={search} placeholder="Search"
                                    onChange={this.handleChange1('search')} />
                            </div>
                            <div style={{marginLeft: '10px'}}>
                                <Dropdown fluid placeholder='Status' style={{width: '100px'}} 
                                    search selection onChange={this.selectStatus}
                                    options={
                                        [
                                            {key: 'All', text: 'All', value: 'All'},
                                            {key: 'Used', text: 'Used', value: 'Process'},
                                            {key: 'Return', text: 'Return', value: 'Return'},
                                        ]
                                    } value={filterStatus} />
                            </div>
                        </div><br/>
                        <table width="100%" id="table">
                            <tr>
                                <th id='tableheader'><center>Sino</center></th>
                                <th id='tableheader'><center>Serial Number</center></th>
                                <th id='tableheader'><center>Partno</center></th>
                                <th id='tableheader'><center>Spare Name</center></th>
                                <th id='tableheader'><center>Rate</center></th>
                                <th id='tableheader'><center>MRP</center></th>
                                <th id='tableheader'><center>QTY</center></th>
                                <th id='tableheader'><center>Status</center></th>
                                <th id='tableheader'><center>Dis%</center></th>
                                <th id='tableheader'><center>Dis Rs</center></th>
                                <th id='tableheader'><center>Taxable Price</center></th>
                                <th id='tableheader'><center>TAX</center></th>
                                <th id='tableheader'><center>Tax Price</center></th>
                                <th id='tableheader'><center>Total</center></th>
                                { this.props.item.status == 1 || this.props.item.status == '1' ?
                                    <th id='tableheader'><center>Action</center></th>: null
                                }
                                
                            </tr>
                            {
                                data.map((c) => {
                                    if (filterStatus == 'Used') {
                                        filterStatus = 'Process';
                                    }
                                    if (c.sparestatus == filterStatus || filterStatus == 'All') {
                                        let spareName = c.spare_name;
                                        let partno = c.partno;
                                        try {
                                            spareName = spareName.toUpperCase();
                                            partno = partno.toUpperCase();
                                            search = search.toUpperCase();
                                        } catch (error) {
                                            spareName = c.spare_name;
                                            partno = c.partno;
                                            search = search;
                                        }
                                        if (!search || spareName.includes(search) || partno.includes(search)) {
                                            let uprice = this.convertIntoNumber(c.uprice);
                                            let qty = this.convertIntoNumber(c.qty);
                                            let tax = this.convertIntoNumber(c.tax);
                                            let mrp = uprice + ((uprice * tax)/100);
                                            return (
                                                <tr>
                                                    <td>{i++}</td>
                                                    <td>{c.serial_number}</td>
                                                    <td>{c.partno}</td>
                                                    <td>{c.spare_name}</td>
                                                    <td style={{textAlign: 'right'}}>{this.makeDecimal(uprice)}</td>
                                                    <td style={{textAlign: 'right'}}>{this.makeDecimal(mrp)}</td>
                                                    <td style={{textAlign: 'right'}}>{c.qty}</td>
                                                    <td>{c.sparestatus == 'Process' ? 'Used' : c.sparestatus }</td>
                                                    <td style={{textAlign: 'right'}}>{c.discper}</td>
                                                    <td style={{textAlign: 'right'}}>{this.makeDecimal(this.convertIntoNumber(c.disc))}</td>
                                                    <td style={{textAlign: 'right'}}>{this.makeDecimal(uprice * qty)}</td>
                                                    <td style={{textAlign: 'right'}}>{c.tax}</td>
                                                    <td style={{textAlign: 'right'}}>{this.makeDecimal(((uprice * tax)/100) * qty)}</td>
                                                    <td style={{textAlign: 'right'}}>{c.totprice}</td>
                                                    { (this.props.item.status == 1 || this.props.item.status == '1') && c.sparestatus == 'Process' ?
                                                        <td onClick={ () => this.editSpares(c)} style={{textAlign: 'center', cursor: 'pointer'}}>
                                                            Return
                                                        </td>: 
                                                        null
                                                    }
                                                </tr>
                                            )
                                        }
                                    }
                                })
                            }
                        </table>
                        <br/>
                        { this.props.item.status == 1 || this.props.item.status == '1'?
                            <AddSpare refresh={this.getSpares} item={this.props.item} />
                            : null
                        }

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}